module.exports = __webpack_public_path__ + "img/bg.ff7e91dc.png";